import ReactDOM from "react-dom";

export function mountApp(tree, rootElement) {
  // Prerender saves a browser snapshot after asynchronous data has loaded.
  // It is not matching SSR state: hydrating it can retain another section's
  // classes and links when the client starts with empty/loading data.
  // Keep the snapshot visible until startup, then mount a fresh live tree.
  ReactDOM.render(tree, rootElement);
}
